<template>
  <div class="fixed left-6 top-1/2 -translate-y-1/2 z-[999]">
    <div class="flex flex-col items-center gap-4">
      <transition
          enter-active-class="transition-all duration-300 ease-out"
          leave-active-class="transition-all duration-200 ease-in"
          enter-class="opacity-0 scale-75 -translate-y-2"
          enter-to-class="opacity-100 scale-100 translate-y-0"
          leave-class="opacity-100 scale-100 translate-y-0"
          leave-to-class="opacity-0 scale-75 -translate-y-2"
      >
        <button
            v-if="navOpen"
            @click="openCurrentPageInNewTab"
            title="باز کردن در تب جدید"
            class="group relative w-12 h-12 rounded-2xl bg-emerald-900/80 backdrop-blur-xl border border-emerald-400/30
           shadow-2xl shadow-emerald-500/20 flex items-center justify-center transition-all duration-300
           hover:border-emerald-400/60 hover:shadow-emerald-500/30 hover:scale-105"
        >
          <div
              class="absolute inset-0 rounded-2xl bg-gradient-to-r from-emerald-400/20 to-amber-400/20 opacity-0 group-hover:opacity-100 transition-opacity"></div>

          <svg class="w-5 h-5 text-emerald-300 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 5v14M5 12h14"
            />
          </svg>
        </button>
      </transition>
      <button
          @click="$emit('toggle-nav')"
          class="group relative w-12 h-12 rounded-2xl  backdrop-blur-xl border flex items-center justify-center transition-all duration-300
               hover:border-amber-400/60 hover:shadow-amber-500/30 hover:scale-105"
          :class="
          navOpen?
           'bg-white/10 border-white shadow-2xl shadow-blue-500/20'
           :
           'bg-white/20 border-white shadow-2xl shadow-blue-500/20'
"
      >
        <div
            class="absolute inset-0 rounded-2xl bg-gradient-to-r from-amber-400/20 to-pink-400/20 opacity-0 group-hover:opacity-100 transition-opacity"></div>
        <svg v-if="!navOpen" class="w-5 h-5 text-amber-300 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-width="2" d="M4 7h16M4 12h10M4 17h16"/>
        </svg>
        <svg v-else class="w-5 h-5 text-amber-300 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 6l12 12M18 6L6 18"
          />
        </svg>
      </button>

      <transition
          enter-active-class="transition-all duration-300 ease-out"
          leave-active-class="transition-all duration-200 ease-in"
          enter-class="opacity-0 transform -translate-x-4"
          enter-to-class="opacity-100 transform translate-x-0"
          leave-class="opacity-100 transform translate-x-0"
          leave-to-class="opacity-0 transform -translate-x-4"
      >
        <div
            v-if="navOpen"
            class="flex flex-col gap-3 px-3 py-4 rounded-3xl bg-slate-900/80 backdrop-blur-xl border border-white/10
                 shadow-2xl shadow-amber-500/20"
        >
          <button
              @click="$emit('set-tab', 'pos')"
              class="group relative w-12 h-12 rounded-2xl flex flex-col items-center justify-center text-[10px] gap-1
                   transition-all duration-300"
              :class="activeTab === 'pos'
              ? 'bg-gradient-to-b from-amber-400 via-amber-500 to-amber-300 text-slate-950 shadow-2xl shadow-amber-500/40'
              : 'bg-slate-800/50 text-slate-100 hover:bg-slate-700/80 border border-white/5 hover:border-amber-400/20'"
          >
            <div v-if="activeTab === 'pos'"
                 class="absolute inset-0 rounded-2xl bg-gradient-to-b from-amber-400/20 to-amber-300/20"></div>
            <svg class="w-4 h-4 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 3h18M5 7h14v10a2 2 0 01-2 2H7a2 2 0 01-2-2V7z"/>
            </svg>
            <span class="relative z-10 font-semibold">سفارش</span>
          </button>

          <button
              @click="$emit('set-tab', 'orders')"
              class="group relative w-12 h-12 rounded-2xl flex flex-col items-center justify-center text-[10px] gap-1
                   transition-all duration-300"
              :class="activeTab === 'orders'
              ? 'bg-gradient-to-b from-amber-400 via-amber-500 to-amber-300 text-slate-950 shadow-2xl shadow-amber-500/40'
              : 'bg-slate-800/50 text-slate-100 hover:bg-slate-700/80 border border-white/5 hover:border-amber-400/20'"
          >
            <div v-if="activeTab === 'orders'"
                 class="absolute inset-0 rounded-2xl bg-gradient-to-b from-amber-400/20 tto-amber-300/20"></div>
            <svg class="w-4 h-4 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 8h10M7 12h6M5 5h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2z"/>
            </svg>
            <span class="relative z-10 font-semibold">سفارشات</span>
          </button>
          <button
              @click="$emit('set-tab', 'returns')"
              class="group relative w-12 h-12 rounded-2xl flex flex-col items-center justify-center text-[10px] gap-1
                   transition-all duration-300"
              :class="activeTab === 'returns'
              ? 'bg-gradient-to-b from-amber-400 via-amber-500 to-amber-300 text-slate-950 shadow-2xl shadow-amber-500/40'
              : 'bg-slate-800/50 text-slate-100 hover:bg-slate-700/80 border border-white/5 hover:border-amber-400/20'"
          >
            <div v-if="activeTab === 'returns'"
                 class="absolute inset-0 rounded-2xl bg-gradient-to-b from-amber-400/20 tto-amber-300/20"></div>
            <svg
                class="w-4 h-4 relative z-10"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"/>
            </svg>
            <span class="relative z-10 font-semibold">مرجوعی</span>
          </button>
          <button
              @click="$emit('set-tab', 'stock-exit')"
              class="group relative w-12 h-12 rounded-2xl flex flex-col items-center justify-center text-[10px] gap-1
                   transition-all duration-300"
              :class="activeTab === 'stock-exit'
              ? 'bg-gradient-to-b from-amber-400 via-amber-500 to-amber-300 text-slate-950 shadow-2xl shadow-amber-500/40'
              : 'bg-slate-800/50 text-slate-100 hover:bg-slate-700/80 border border-white/5 hover:border-amber-400/20'"
          >
            <div v-if="activeTab === 'stock-exit'"
                 class="absolute inset-0 rounded-2xl bg-gradient-to-b from-amber-400/20 to-amber-300/20"></div>
            <svg class="w-4 h-4 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6.5 12 3l8 3.5v9L12 21l-8-5.5v-9z"
              />
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6.5 12 11l8-4.5"
              />
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 11v10"
              />
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 14h5m0 0-2-2m2 2-2 2"
              />
            </svg>
            <span class="relative z-10 font-semibold">بازگشت</span>
          </button>
          <button
              @click="$emit('set-tab', 'stock-manage')"
              class="group relative w-12 h-12 rounded-2xl flex flex-col items-center justify-center text-[10px] gap-1
                   transition-all duration-300"
              :class="activeTab === 'stock-manage'
              ? 'bg-gradient-to-b from-amber-400 via-amber-500 to-amber-300 text-slate-950 shadow-2xl shadow-amber-500/40'
              : 'bg-slate-800/50 text-slate-100 hover:bg-slate-700/80 border border-white/5 hover:border-amber-400/20'"
          >
            <div v-if="activeTab === 'stock-manage'"
                 class="absolute inset-0 rounded-2xl bg-gradient-to-b from-amber-400/20 to-amber-300/20"></div>
            <svg class="w-4 h-4 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 6h12"
              />
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 12h8"
              />
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 18h12"
              />
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h.01M4 12h.01M4 18h.01"
              />
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 12h4m0 0-2-2m2 2-2 2"
              />
            </svg>
            <span class="relative z-10 font-semibold">سوابق</span>
          </button>

          <button
              @click="$emit('set-tab', 'overview')"
              class="group relative w-12 h-12 rounded-2xl flex flex-col items-center justify-center text-[10px] gap-1
                   transition-all duration-300"
              :class="activeTab === 'overview'
              ? 'bg-gradient-to-b from-amber-400 via-amber-500 to-amber-300 text-slate-950 shadow-2xl shadow-amber-500/40'
              : 'bg-slate-800/50 text-slate-100 hover:bg-slate-700/80 border border-white/5 hover:border-amber-400/20'"
          >
            <div v-if="activeTab === 'overview'"
                 class="absolute inset-0 rounded-2xl bg-gradient-to-b from-amber-400/20 to-amber-300/20"></div>
            <svg class="w-4 h-4 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 19h4V9H4v10zm6 0h4V5h-4v14zm6 0h4V13h-4v6z"/>
            </svg>
            <span class="relative z-10 font-semibold">گزارش</span>
          </button>
          <button
              @click="$emit('logout')"
              class="group relative w-12 h-12 rounded-2xl flex flex-col items-center justify-center text-[10px] gap-1
                   transition-all duration-300"
          >
            <div class="absolute inset-0 rounded-2xl bg-gradient-to-b from-gray-400/20 to-red-500/20"></div>
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5m0 0l-5-5m5 5H3"/>
            </svg>
            <span class="relative z-10 font-semibold">خروج</span>
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PosSidebarNav',

  props: {
    navOpen: {
      type: Boolean,
      default: false
    },
    activeTab: {
      type: String,
      default: 'pos'
    }
  },
  methods: {
    openCurrentPageInNewTab() {
      window.open(window.location.href, '_blank', 'noopener,noreferrer')
    }
  }
}
</script>